var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToggle } from '@hn-front/utils';
import { styled } from 'styled-components';
import { LinkButton } from '@hn-ui/buttons';
import { Delete } from '@hn-ui/icons';
import { SubTitle, Text } from '../../Common';
import { CancelModal } from './CancelModal';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1fxde0r" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  padding: 24px 0;\n"], ["\n  display: flex;\n  flex-flow: column;\n  padding: 24px 0;\n"])));
var ScText = styled(Text).withConfig({ displayName: "ScText", componentId: "sc-2zvp0h" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  margin-top: 8px;\n"], ["\n  color: ", ";\n  margin-top: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black40;
});
var RedDelete = function () { return _jsx(Delete, { color: 'red50' }, void 0); };
var CancelButton = styled(LinkButton).withConfig({ displayName: "CancelButton", componentId: "sc-1dee4wa" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 16px;\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    &&& > div > svg > path {\n      fill: ", ";\n    }\n  }\n"], ["\n  margin-top: 16px;\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    &&& > div > svg > path {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
});
var CancelSection = function (_a) {
    var onCancel = _a.onCancel, rest = __rest(_a, ["onCancel"]);
    var _b = useToggle(), isCancelOpen = _b.isToggled, toggleCancel = _b.toggle;
    var handleOnCancel = function () {
        toggleCancel();
        onCancel();
    };
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(SubTitle, { children: "Math Challenge is successfully scheduled. What\u2019s next?" }, void 0), _jsx(ScText, { children: "Check your inbox for a confirmation email!" }, void 0), _jsx(CancelButton, __assign({ LeftIcon: RedDelete, fit: true, onClick: toggleCancel }, { children: "Cancel challenge" }), void 0), _jsx(CancelModal, { isOpen: isCancelOpen, onOk: toggleCancel, onCancel: handleOnCancel }, void 0)] }), void 0));
};
export { CancelSection };
var templateObject_1, templateObject_2, templateObject_3;
